import { COLLECTION_PRODUCT_TYPES } from "@constants/orders/cart";
import {
  dsd,
  medley,
  themedBox,
  snacks,
  snacksKit,
  byo,
  swagmagic,
  giftCard,
} from "@constants/products/detail";

export const isCollectionTypeProduct = (intent) => {
  return COLLECTION_PRODUCT_TYPES.includes(intent);
};

export const isMedleyProduct = (intent) => intent === medley;
export const isThemedBoxProduct = (intent) => intent === themedBox;
export const isSnackOrDSDProduct = (intent) => [dsd, snacks, snacksKit].includes(intent);
export const isByoProduct = (intent) => intent === byo;
export const isSwagProduct = (intent) => intent === swagmagic;
export const isDSDProduct = (intent) => intent === dsd;
export const isGiftCardProduct = (intent) => intent === giftCard;
export const getProductType = (product) => {
  const { intent, lockerProduct } = product || {};
  if (isMedleyProduct(intent)) return "medley";
  if (isSwagProduct(intent)) return "swag";
  if (isThemedBoxProduct(intent)) return "themed_box";
  if (isCollectionTypeProduct(intent)) return "collection";
  if (isByoProduct(intent)) return "byo_medley";
  if (lockerProduct) return "locker";
  return "standard";
};

export const getProductCategory = (product) => {
  if (product?.taxons?.length > 1) {
    return product.taxons.map((taxon) => taxon.name);
  }
  return product?.relatedTaxon?.name || "Uncategorized";
};
